export const MessageContentType = {
  TEXT: 'Text',
  CONFIRM_ACTION: 'ConfirmAction',
  LIST: 'List',
  ACTION_STEP: 'ActionStep',
  ACTION_STEP_GROUP: 'ActionStepGroup',
  GUIDELINE_CITATION_BADGE: 'GuidelineCitationBadge',
  GUIDELINE_EXPANDER_CARD: 'GuidelineExpanderCard',
};

export const ListItemStatus = {
  DEFAULT: 'Default',
  ERROR: 'Error',
};
